import React, { useEffect, useRef } from 'react';
import { Video } from '../styled/video';

interface IProps {
  liveStream: MediaStream;
}

const Preview: React.FC<IProps> = ({ liveStream }) => {
  const refVideo = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!refVideo.current) return;
    refVideo.current.srcObject = liveStream;
  }, [liveStream]);

  return <Video ref={refVideo} width="300px" height="500px" autoPlay />;
};

export default Preview;
